module.exports = __webpack_public_path__ + "img/Information_flow.483b738f.svg";